<template><div><h1>VUX V2.6.4 released</h1>
<h2><a href="/en/components/alert.html">Alert</a></h2>
<ul><li>[feature] support prop:mask-z-index</li>
</ul>
<h2><a href="/en/components/calendar.html">Calendar</a></h2>
<ul><li>[feature] support prop:display-format #2023</li>
</ul>
<h2><a href="/en/components/cell.html">Cell</a></h2>
<ul><li>[feature] support prop:align-items</li>
</ul>
<h2><a href="/en/components/checklist.html">Checklist</a></h2>
<ul><li>[feature] support method:getFullValue #2022</li>
</ul>
<h2><a href="/en/components/confirm.html">Confirm</a></h2>
<ul><li>[feature] support prop:mask-z-index</li>
</ul>
<h2><a href="/en/components/previewer.html">Previewer</a></h2>
<ul><li>[feature] automatically update view if one slide is deleted</li>
</ul>
<h2><a href="/en/components/x-dialog.html">XDialog</a></h2>
<ul><li>[feature] support prop:mask-z-index</li>
</ul>
<h2><a href="/en/components/close-dialogs.html">CloseDialogs</a></h2>
<ul><li>[feature] new plugin for closing all dialogs #2025</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.6.4 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.6.4-128.vue?3f457640